import { IApplicationContext } from '../../types/application';
import { makeContextModule } from '@cian/react-utils';

export const {
  Context: AppContext,
  useContext: useApplicationContext,
  withContext: withApplicationContext,
} = makeContextModule<IApplicationContext>({
  contextName: 'ApplicationContext',
});
